/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
var s_ajaxListener = new Object();
s_ajaxListener.tempOpen = XMLHttpRequest.prototype.open;
s_ajaxListener.tempSend = XMLHttpRequest.prototype.send;

XMLHttpRequest.prototype.open = function(a,b) {
  if (!a) var a='';

  if (!b) var b='';
  s_ajaxListener.tempOpen.apply(this, arguments);
  s_ajaxListener.method = a;  
  s_ajaxListener.url = b;
  if (a.toLowerCase() == 'get') {
    s_ajaxListener.data = b.split('?');
    s_ajaxListener.data = s_ajaxListener.data[1];
  }
}

XMLHttpRequest.prototype.send = function(a,b) {
  if (!a) var a='';
  if (!b) var b='';
  s_ajaxListener.tempSend.apply(this, arguments);
  if(s_ajaxListener.method.toLowerCase() == 'post')s_ajaxListener.data = a;
  s_ajaxListener.callback();
}

s_ajaxListener.callback = function () {     
  if (this.url.indexOf('/cart/change.js') != -1){         
    setTimeout(function(){ 
      var xhttp = new XMLHttpRequest();
      var elem = document.querySelector('[data-cart-weight]');
      var unit = elem.innerText.split(" ")[1]
      xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
          elem.textContent = parseFloat(JSON.parse(this.response).total_weight / 1000).toFixed(1) + " " + unit
        }
      };
      xhttp.open("GET", "/cart.js", true);
      xhttp.send();
    }, 500);
  }
}